export default function BulletList({
  items,
  className = "",
  spacing = "space-y-1",
}) {
  return (
    <ul
      className={`list-disc ${spacing} pl-5 marker:text-coral ${className}`}
    >
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
